import { makeStyles } from '@material-ui/core'

export default makeStyles({
  button_text: {
    fontFamily: 'Yu Gothic',
    fontSize: 16,
    fontWeight: 'bold',
    color: 'rgba(0,0,0,0.85)',
    borderRadius: '0%',
    '&:hover': {
      backgroundColor: 'rgba(205,92,92,1)',
    },
  },
})
